import 'bootstrap';

const form = document.getElementById('contact-form');
const messageDiv = document.getElementById('form-message');

form.addEventListener('submit', function(e) {
    e.preventDefault(); // evita que la página se recargue
    const formData = new FormData(form);

    fetch(form.action, {
        method: form.method,
        body: formData
    })
    .then(response => response.text())
    .then(data => {
        // Solo actualizamos el contenido y mostramos
        messageDiv.innerHTML = data;
        messageDiv.style.display = 'block'; // simple, sin animación
        form.reset(); // limpia formulario
        if (typeof grecaptcha !== 'undefined') grecaptcha.reset(); // reset reCAPTCHA
    })
    .catch(err => {
        messageDiv.innerHTML = '<p class="text-danger">Error al enviar el mensaje.</p>';
        messageDiv.style.display = 'block';
    });
});
